import { all, call } from 'redux-saga/effects'

import {
  loginSaga,
  getProfileSaga,
  saveProfileSaga,
  passwordRecoverySaga,
  changePasswordSaga,
  getReportDataByTokenSaga,
  resetPasswordSaga
} from './sagas/user'

import { getAuthSaga } from './sagas/auth'

import {
  getReportSaga,
  getReportToInsuranceSaga,
  getBeneficiariesToSelectSaga,
  getBeneficiariesWithCollectionSaga,
  getCsvDataSaga,
  saveBeneficiarySaga,
  checkBeneficiariesReadSaga,
  saveBeneficiariesExamsSaga,
  getCountBeneficiariesWithCollectionSaga,
  getCountBeneficiariesByCompanyOrProgrammeSaga,
  getBeneficiariesToMessageSaga,
  getBeneficiariesToAccessControlSaga
} from './sagas/beneficiary'

import {
  getCompaniesSaga,
  getCompanySaga
} from './sagas/company'

import {
  getProgrammeSaga,
  getProgrammesSaga
} from './sagas/programme'

import {
  listEquipmentsByInsurerSaga
} from './sagas/equipment'

import {
  listLoansSaga,
  listClosedLoansSaga,
  refundLoanSaga,
  getTermDataSaga,
  getActiveTermsSaga
} from './sagas/loan'

import {
  getDiabetesOverviewSaga,
  getHypertensionAndDyslipidemiaOverviewSaga,
  getLifeHabitsOverviewSaga,
  getOverweightOverviewSaga,
  getRisksOverviewSaga,
  getEngagementBeneficiaryOverviewSaga,
  getEquipmentOverviewSaga
} from './sagas/overview'

import { listCollectionsSaga } from './sagas/collection'
import {
  listImportedExamsSaga,
  getLastImportedAtSaga,
  searchNewExamsSaga,
  getCandidateCollectionsSaga,
  importErrorToCollectionSaga
}
  from './sagas/exam'

import { listActivitiesSaga, createActivitySaga } from './sagas/activity'

import {
  getActivitySaga, // GET /activity usado pelo ConfirmEventModal (legado GET_ACIVITY_ACTION)
  getEventsSaga,
  createEventSaga,
  updateEventSaga,
  deleteEventSaga,
  getEventSaga,
} from '@stores/sagas/event'

import { getRoomsSaga } from './sagas/room'

import { listMessagesSaga, sendNotificationSaga, getMessageSaga } from './sagas/notification'

import { profileImageSaga } from './sagas/profileImage'

export default function* rootSaga() {
  yield all({

    profileImage: call(profileImageSaga),

    listActivities: call(listActivitiesSaga),
    createActivity: call(createActivitySaga),

    getActivity: call(getActivitySaga),
    getEvents: call(getEventsSaga),
    createEvent: call(createEventSaga),
    updateEvent: call(updateEventSaga),
    deleteEvent: call(deleteEventSaga),
    getEvent: call(getEventSaga),

    listRooms: call(getRoomsSaga),

    login: call(loginSaga),
    getProfile: call(getProfileSaga),
    saveProfile: call(saveProfileSaga),
    passwordRecovery: call(passwordRecoverySaga),
    changePassword: call(changePasswordSaga),
    resetPassword: call(resetPasswordSaga),
    getReportDataByToken: call(getReportDataByTokenSaga),

    getAuth: call(getAuthSaga),

    getReport: call(getReportSaga),
    getReportToInsurance: call(getReportToInsuranceSaga),
    getBeneficiariesToSelect: call(getBeneficiariesToSelectSaga),
    getBeneficiariesWithCollection: call(getBeneficiariesWithCollectionSaga),
    getCsvData: call(getCsvDataSaga),
    saveBeneficiary: call(saveBeneficiarySaga),
    checkBeneficiariesRead: call(checkBeneficiariesReadSaga),
    saveBeneficiariesExams: call(saveBeneficiariesExamsSaga),
    getCountBeneficiariesWithCollectionSaga: call(getCountBeneficiariesWithCollectionSaga),
    getCountBeneficiariesByCompanyOrProgramme: call(getCountBeneficiariesByCompanyOrProgrammeSaga),
    getBeneficiariesToMessage: call(getBeneficiariesToMessageSaga),
    getBeneficiariesToAccessControl: call(getBeneficiariesToAccessControlSaga),

    getCompanies: call(getCompaniesSaga),
    getCompany: call(getCompanySaga),

    getProgrammes: call(getProgrammesSaga),
    getProgramme: call(getProgrammeSaga),

    getRisksOverview: call(getRisksOverviewSaga),
    getDiabetesOverview: call(getDiabetesOverviewSaga),
    getOverweightOverview: call(getOverweightOverviewSaga),
    getLifeHabitsOverview: call(getLifeHabitsOverviewSaga),
    getHypertensionAndDyslipidemiaOverview: call(getHypertensionAndDyslipidemiaOverviewSaga),
    getEngagementBeneficiaryOverview: call(getEngagementBeneficiaryOverviewSaga),
    getEquipmentOverview: call(getEquipmentOverviewSaga),

    listCollections: call(listCollectionsSaga),

    listImportedExams: call(listImportedExamsSaga),
    getLastImportedAt: call(getLastImportedAtSaga),
    searchNewExams: call(searchNewExamsSaga),
    getCandidateCollections: call(getCandidateCollectionsSaga),
    importErrorToCollection: call(importErrorToCollectionSaga),

    listEquipmentsByInsurer: call(listEquipmentsByInsurerSaga),

    listLoans: call(listLoansSaga),
    listClosedLoans: call(listClosedLoansSaga),
    refundLoan: call(refundLoanSaga),
    getTermData: call(getTermDataSaga),
    getActiveTerms: call(getActiveTermsSaga),

    sendNotification: call(sendNotificationSaga),
    listMessages: call(listMessagesSaga),
    getMessage: call(getMessageSaga)

  })
}
